function initScrollReveal() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
    return;
  }

  const targets = Array.from(document.querySelectorAll('.shopify-section')).filter(
    (el) =>
      !el.closest('#header-group') &&
      !el.closest('footer') &&
      el.id !== 'shopify-section-cart-drawer-section' &&
      !el.id.includes('media_with_content_RVymQU') &&
      // A CSS transform on any ancestor breaks position:fixed for descendants
      // (it creates a new containing block), so sections hosting fixed-position
      // UI like the sticky add-to-cart bar must never receive the reveal transform.
      !el.querySelector('sticky-add-to-cart')
  );

  if (!targets.length) return;

  const textSelector =
    'h1, h2, h3, h4, [class*="-eyebrow-"], [class*="-heading-"], [class*="-subheading-"], [class*="-description-"]';

  // Sections with their own dedicated, hand-tuned staggered animation
  // (rather than the generic heading-only stagger below).
  const sectionsWithCustomStagger = ['section_GwiQd3'];

  targets
    .filter((section) => !sectionsWithCustomStagger.some((id) => section.id.includes(id)))
    .forEach((section) => {
    const textEls = Array.from(section.querySelectorAll(textSelector)).filter(
      (el) => !el.closest('.product-card, [class*="-card-"], [class*="-card__"]')
    );
    textEls.forEach((el, index) => {
      el.classList.add('stagger-text');
      el.style.setProperty('--stagger-index', index);
    });
  });

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('scroll-reveal--visible');
          entry.target.querySelectorAll('.stagger-text').forEach((el) => {
            el.classList.add('stagger-text--visible');
          });
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.1, rootMargin: '0px 0px -80px 0px' }
  );

  targets.forEach((el) => {
    el.classList.add('scroll-reveal');
    observer.observe(el);
  });
}

// Wait two paint cycles for initial layout to settle before observing, instead
// of the page's full `load` event — on a slow connection with many images,
// `load` can take a long time, leaving already-scrolled-to content invisible
// far longer than necessary. Images use explicit width/height so their layout
// space is reserved before they finish downloading.
requestAnimationFrame(() => requestAnimationFrame(initScrollReveal));
